module.exports = __webpack_public_path__ + "media/honey-icons/icon-camera-19270d81.svg";